module.exports = __webpack_public_path__ + "static/media/ICONS-HEALTH_CARE.4a9d96d7.svg";